import { render, staticRenderFns } from "./EditTerms.vue?vue&type=template&id=6b32029e&scoped=true"
import script from "./EditTerms.vue?vue&type=script&lang=js"
export * from "./EditTerms.vue?vue&type=script&lang=js"
import style0 from "./EditTerms.vue?vue&type=style&index=0&id=6b32029e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b32029e",
  null
  
)

export default component.exports